import { Notification, NotificationsCount } from './types'
import client from '../../client'

export const getNotifications = () => client.get<{ results: Notification[] }>('v1/notifications/')

export const getNotificationsCount = () => client.get<NotificationsCount>('v1/notifications/count/')

export const getPaginateNotifications = (newPage: string) =>
  client.get<{ results: Notification[] }>(newPage)
